import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    paymentMethods: {
      '& .MuiInput-underline.Mui-disabled:before': {
        borderBottomStyle: 'solid',
      },
    },
    paymentSelect: {
      width: '100%',
      padding: '0 0.5625rem',
      fontSize: '0.875rem',
    },
    stripeError: {
      marginTop: '1rem',
      color: theme.palette.error.main,
    },
  };
});

export default useStyles;
